import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.9987 15.1693C4.04536 15.1693 0.832031 11.9559 0.832031 8.0026C0.832031 4.04927 4.04536 0.835938 7.9987 0.835938C11.952 0.835938 15.1654 4.04927 15.1654 8.0026C15.1654 11.9559 11.952 15.1693 7.9987 15.1693ZM7.9987 1.83594C4.5987 1.83594 1.83203 4.6026 1.83203 8.0026C1.83203 11.4026 4.5987 14.1693 7.9987 14.1693C11.3987 14.1693 14.1654 11.4026 14.1654 8.0026C14.1654 4.6026 11.3987 1.83594 7.9987 1.83594Z",
			fill: "#787878"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.11161 10.3889C5.98495 10.3889 5.85828 10.3422 5.75828 10.2422C5.56495 10.0489 5.56495 9.72885 5.75828 9.53552L9.53161 5.76219C9.72495 5.56885 10.0449 5.56885 10.2383 5.76219C10.4316 5.95552 10.4316 6.27552 10.2383 6.46885L6.46495 10.2422C6.37161 10.3422 6.23828 10.3889 6.11161 10.3889Z",
			fill: "#787878"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.88495 10.3889C9.75828 10.3889 9.63161 10.3422 9.53161 10.2422L5.75828 6.46885C5.56495 6.27552 5.56495 5.95552 5.75828 5.76219C5.95161 5.56885 6.27161 5.56885 6.46495 5.76219L10.2383 9.53552C10.4316 9.72885 10.4316 10.0489 10.2383 10.2422C10.1383 10.3422 10.0116 10.3889 9.88495 10.3889Z",
			fill: "#787878"
		})
	]
});
export default SvgCloseCircle;
